import React, { createContext, useEffect, useState } from 'react';
import { getCountries } from '../functions';

export const CountriesContext = createContext({ countries: [] });

export const CountriesProvider = ({ children }) => {
    const [countries, setCountries] = useState([]);

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const res = await getCountries();
                if (!mounted) return;
                setCountries(res ?? []);
            } catch (err) {
                console.error('getCountries failed', err);
            }
        })();
        return () => { mounted = false; };
    }, []);

    return (
        <CountriesContext.Provider value={{ countries }}>
            {children}
        </CountriesContext.Provider>
    );
};